import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { Match2PayWithdrawApi } from '../../../../../api/request/wallet/withdraw.js';
import { handleApiError } from '../../../../../utils/handleApiError.js';

const Match2Pay = ({ amount, resetAll, paymentGatewayId, validateAmount }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            if (validateAmount) {
                toast.error(validateAmount);
                return;
            }
            if (!amount) {
                toast.error('Please enter withdraw amount');
                return;
            }
            const params = {
                userId: userDetails?._id,
                amount: Number(amount),
                withdrawAddress: values?.walletAddress,
                PaymentGatwayId: paymentGatewayId
            };

            const { data } = await Match2PayWithdrawApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form?.resetFields();
                resetAll();
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div>
            <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
                <div className="grid sm:grid-cols-2 gap-5">
                    <Form.Item
                        name='walletAddress'
                        label={<span className="text-lg text-gray-500 font-medium">Wallet Address</span>}
                        rules={[{ required: true, message: 'Please enter Wallet Address.' }]}
                    >
                        <Input placeholder="Enter Wallet Address" size='large' className='py-3 md:py-1.5' />
                    </Form.Item>
                </div>

                <Form.Item
                    name='conditions'
                    valuePropName="checked"
                    rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                >
                    <Checkbox className='mt-4'>
                        Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                    </Checkbox>
                </Form.Item>

                <LoadableButton
                    className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-3 md:py-2 w-full md:w-auto uppercase themeHover duration-500'
                    type="submit"
                    lable='Submit'
                    isLoading={isLoading}
                    loadingLable='Adding request...'
                />
            </Form>
        </div>
    )
}

export default Match2Pay
